import { EPackageType } from '../../../../interfaces/packageType';
import BroadbandUsage from './broadbandUsage/BroadbandUsage';
import NoneBroadbandUsage from './noneBroadbandUsage/NoneBroadbandUsage';

interface IProps {
  selectedCircuitId: string;
  selectedPackageType: EPackageType;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const MonthlyUsage = (props: IProps) => {
  const { selectedPackageType } = props;

  return (
    <>
      {selectedPackageType === EPackageType.BROADBAND ? (
        <BroadbandUsage {...props} />
      ) : (
        <NoneBroadbandUsage {...props} />
      )}
    </>
  );
};

export default MonthlyUsage;
